import React from "react";
import { PrimeReactProvider } from "primereact/api";
import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router";
import { ROUTES } from "./constants/routes";
import PrivateRoute from "./components/PrivateRoutes/PrivateRoute";
import OidcCallback from "./pages/OidcCallback";
import AuthInit from "./components/Auth/AuthInit";
import { useAuthContext } from "./Context/AuthContext";
import { AuthType } from "./services/Auth/AuthenticationFactory";

const authType: AuthType =
  import.meta.env.VITE_AUTH_PROVIDER as AuthType;

const RootRedirectHandler: React.FC = () => {
  const { isAuthenticated } = useAuthContext();

  if (authType === "siteminder") {
    return isAuthenticated ? (
      <Navigate
        to="/pages/home"
        replace
      />
    ) : (
      <AuthInit authType={authType} />
    );
  }

  return (
    <Navigate
      to="/pages/home"
      replace
    />
  );
};

function App() {
  return (
    <PrimeReactProvider>
      <Router useTransitions={false}>
        <Routes>
          <Route
            path="/"
            element={<RootRedirectHandler />}
          />

          <Route
            path="/odp/signin-oidc-cwopa"
            element={<OidcCallback />}
          />

          {ROUTES.map((route) => (
            <Route
              key={route.path}
              path={route.path}
              element={
                route.isPrivate ? (
                  <PrivateRoute
                    allowedRoles={route.allowedRoles}
                  >
                    {route.element}
                  </PrivateRoute>
                ) : (
                  route.element
                )
              }
            />
          ))}

          <Route
            path="*"
            element={
              <Navigate
                to="/pages/home"
                replace
              />
            }
          />
        </Routes>
      </Router>
    </PrimeReactProvider>
  );
}

export default App;